module.exports = __webpack_public_path__ + "static/spinner-395604ec84b1c31c001fcbb55c701c66.gif";